<template>
  <div class="discuss-section">
    <img src="@/assets/img/images/home/logo-b.png" alt="" />
    <p class="p2">{{ $t("home.v2.discuss.title1") }}</p>
    <p class="p2">{{ $t("home.v2.discuss.title2") }}</p>
    <p class="p4" @click="openExternal('https://about.rwa.ltd/contact.html')">
      {{ $t("home.v2.discuss.button") }}
      <i class="el-icon-arrow-right"></i>
    </p>
  </div>
</template>

<script>
export default {
  name: "DiscussSection",
  data() {
    return {};
  },
  created() {},
  methods: {
    openExternal(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.discuss-section {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  background: #E05807;
  img{
    width: 162px;
    height: 44px;
    margin-bottom: 44px;
  }
  .p2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #ffffff;
    line-height: 70px;
  }
  .p3 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #ffffff;
    margin-top: 16px;
  }
  .p4 {
    display: flex;
    align-items: center;
    height: 85px;
    line-height: 85px;
    text-align: center;
    padding: 0 20px;
    background: #ffffff;
    margin-top: 82px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    border-radius: 12px;
    i {
      margin-left: 20px;
    }
  }
}
</style>
